var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCreateInvoice = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M16.437.828H3.771a2.37 2.37 0 0 0-2.375 2.375v15.834l1.583-1.584 1.583 1.584 1.584-1.584 1.551 1.584 1.615-1.584 1.584 1.584 1.583-1.584 1.583 1.584V3.203"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M18.813 3.203v1.583h-4.75V3.203c0-.704.3-1.338.791-1.765a2.372 2.372 0 0 1 3.958 1.765M5.604 11.911s0 1.584 2.225 1.584c2.787 0 2.787-3.793 0-4.355s-2.787-4.354 0-4.354c1.734 0 1.734 1.583 1.734 1.583M7.98 3.203v1.583M7.98 13.495v1.583"
})));
export default SvgCreateInvoice;